export default __webpack_public_path__ + "static/media/steps-cover-8-2.0a44ef41.png";